<script setup lang="ts">
import AdvertisingBlock from '~/entities/contacts/ui/AdvertisingBlock.vue';

const authorsInfo = [
  {
    job: 'Управляющий партнер и издатель',
    author: 'Борис Болтянский',
    mail: '',
  },
  {
    job: 'Главный редактор сайта cre.ru',
    author: 'Павел Владимирович Назаркин',
    mail: 'p.nazarkin@cre.ru',
  },
  {
    job: 'Шеф-редактор cre журналы',
    author: 'Екатерина Евгеньевна Горячева',
    mail: 'e.goryacheva@cre.ru',
  },
  {
    job: 'Редакционный директор',
    author: 'Анастасия Викторовна Ляликова',
    mail: 'a.lyalikova@cre.ru',
  },
  {
    job: 'Коммерческий директор',
    author: 'Алена Андреасовна Мужикян',
    mail: 'a.krivenko@cre.ru',
  },
  {
    job: 'Руководитель CRE Awards',
    author: 'Елена Юрьевна Маслова',
    mail: 'e.maslova@cre.ru',
  },
  {
    job: 'Руководитель отдела производства',
    author: 'Михаил Альбертович Лебедев',
    mail: 'm.lebedev@cre.ru',
  },
];

const footerInfo = [
  {
    title: 'Для отправки пресс-релизов',
    mail: 'news@cre.ru',
  },
  {
    title: 'Вопросы и предложения по работе сайта',
    mail: 'webteam@cre.ru',
  },
  {
    title: 'По другим вопросам',
    mail: 'info@cre.ru',
  },
];
</script>

<template>
  <div :class="$style.contacts">
    <div :class="$style.contacts__table">
      <div
        v-for="(table, index) in authorsInfo"
        :key="`table-${index}`"
        :class="$style.contacts__row"
      >
        <div :class="$style.contacts_job">{{ table.job }}</div>
        <div :class="$style.contacts__information">
          <div v-if="table.author" :class="$style.contacts_author">
            {{ table.author }}
          </div>
          <div v-if="table.mail" :class="$style.contacts__links">
            <Icon name="my-icon:i-mail" size="20px"></Icon>
            <a :href="`mailto:${table.mail}`" :class="$style.contacts_link">{{
              table.mail
            }}</a>
          </div>
        </div>
      </div>
    </div>
    <div :class="$style.contacts__description">
      Сетевое издание «CRE.RU» зарегистрировано Федеральной службой по надзору в
      сфере связи, информационных технологий и массовых коммуникаций
      (Роскомнадзор) регистрационный номер Эл № ФС77-91059 от 24.03.2026г. Павел
      Владимирович Назаркин — главный редактор сетевого издания «CRE.RU».
    </div>
    <div :class="$style.contacts__block">
      <div :class="$style.contacts__wrapper">
        <div :class="$style.contacts__wrapperInformation">
          <div :class="$style.contacts__title">Телефон (многоканальный)</div>
          <div :class="$style.contacts__links">
            <Icon name="my-icon:i-call" size="20px" />
            <a href="tel:+74950858818" :class="$style.contacts_link">
              +7 (495) 085-88-18
            </a>
          </div>
        </div>
        <div :class="$style.contacts__wrapperInformation">
          <div :class="$style.contacts__title">Факс</div>
          <div :class="$style.contacts__links">
            <Icon name="my-icon:i-print" size="20px" />
            <a href="tel:+74950858818" :class="$style.contacts_link">
              +7 (495) 085-88-18
            </a>
          </div>
        </div>
      </div>
      <div :class="$style.contacts__adress">
        <div :class="$style.contacts__title">Адрес</div>
        <div :class="$style.contacts__links">
          <Icon name="my-icon:i-location" size="20px" />
          <div :class="$style.contacts_subtitle">
            107023, Россия, г. Москва, ул. Электрозаводская, д. 20, стр. 3
          </div>
        </div>
      </div>
      <div :class="$style.contacts_map">
        <iframe
          src="https://yandex.ru/map-widget/v1/?lang=ru_RU&amp;scroll=true&amp;
            source=constructor-api&amp;um=constructor%3Ac3b3f486e9f25174ba7ee867eb28f231c73fd5469713681bcdc77e8443e2fd8a"
          frameborder="0"
          allowfullscreen="true"
          style="display: block"
        />
      </div>
      <AdvertisingBlock
        button-text="По вопросам рекламы обращайтесь в отдел продаж"
      />
      <div :class="$style.contacts__footer">
        <div
          v-for="(footer, index) in footerInfo"
          :key="`footer-${index}`"
          :class="$style.contacts__texts"
        >
          <div :class="$style.contacts__title">{{ footer.title }}</div>
          <div :class="$style.contacts__links">
            <Icon name="my-icon:i-location" size="20px" />
            <a :href="`mailto:${footer.mail}`" :class="$style.contacts_link">
              {{ footer.mail }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style module lang="scss">
.contacts {
  padding: 0 20px 39px 20px;
  &__table {
    border: 1px solid var(--color-gray-line);
  }

  &__row {
    display: flex;
  }

  &_job {
    @include text_caption1_caps;
    color: var(--color-gray-text);
    padding: var(--space-2-5x);
    border-right: 1px solid var(--color-gray-line);
    width: 50%;
    display: flex;
    align-items: center;
    height: auto;
  }

  &__row:not(:last-child) {
    border-bottom: 1px solid var(--color-gray-line);
  }

  &__information,
  &__adress,
  &__texts {
    padding: var(--space-2-5x);
    width: 50%;
    margin: auto 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &_author {
    @include text_caption1_caps;
    color: var(--color-black-1);
  }

  &__links {
    display: flex;
    align-items: center;
    gap: 8px;

    path {
      fill: var(--color-red-1);
    }
  }

  &_link,
  &_subtitle {
    @include text_caption1_caps;
    text-decoration: none;
    color: var(--color-red-1);
    transform: translateY(1px);
  }

  &__description {
    @include text-body2;
    color: var(--color-black-1);
    padding: 20px 0;
  }

  &__block {
    border: 1px solid var(--color-gray-line);
  }

  &__wrapper {
    display: flex;
    &Information {
      padding: var(--space-2-5x);
      width: 50%;
      margin: auto 0;
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    &Information:first-child {
      border-right: 1px solid var(--color-gray-line);
    }
  }

  &__title {
    @include text_caption1_caps;
    color: var(--color-gray-text);
  }

  &__adress,
  &__texts {
    width: 100%;
    border-top: 1px solid var(--color-gray-line);
  }

  &_map {
    border-top: 1px solid var(--color-gray-line);
    border-bottom: 1px solid var(--color-gray-line);
  }

  iframe {
    width: 100%;
    height: 460px;
  }
}

@media (max-width: 1379px) {
  .contacts {
    iframe {
      height: 300px;
    }
  }
}

@media (max-width: 1023px) {
  .contacts {
    iframe {
      height: 320px;
    }
  }
}

@media (max-width: 767px) {
  .contacts {
    padding-bottom: 20px;
    &__row {
      flex-direction: column;
    }

    &_job {
      width: 100%;
      border-right: none;
    }

    &__information {
      width: 100%;
      padding-top: 0;
    }

    &__wrapper {
      flex-direction: column;
      &Information:first-child {
        border-right: none;
        border-bottom: 1px solid var(--color-gray-line);
      }

      &Information {
        width: 100%;
      }
    }

    iframe {
      height: 194px;
    }
  }
}

@media (max-width: 479px) {
  .contacts {
    padding: 0;
    &__description {
      padding: 20px 16px;
    }

    iframe {
      height: 159px;
    }
  }
}
</style>
